import React from "react";
import { DatePicker, Form, Input, Popover } from "antd";
import moment from "moment";
import { IconQuestion } from "../../../../../../common/ui/icons";

const VehicleLicenseInfo = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <>
      <span className="label">Номер лицензии:</span>

      <div style={{ display: "flex" }}>
        <Form.Item>
          {getFieldDecorator("license_transportation_num")(
            <Input
              style={{ width: 224 }}
              placeholder="Укажите номер лицензии"
              disabled={disabled}
            />
          )}
        </Form.Item>
        <Popover
          title="Лицензия на перевозку"
          placement="topLeft"
          content={
            <p style={{ width: 240 }}>
              Данные лицензии на осуществление перевозок пассажиров и иных лиц
              автобусами необходимы для подачи уведомления в ГИБДД об
              организованной перевозке группы детей
            </p>
          }
        >
          <IconQuestion
            style={{
              color: "#00A8FF",
              fontSize: 24,
              marginLeft: 16,
              alignSelf: "center"
            }}
          />
        </Popover>
      </div>
      <span className="label">Дата регистрации:</span>
      <Form.Item>
        {getFieldDecorator("license_transportation_date")(
          <DatePicker
            style={{ width: 224 }}
            placeholder="Укажите дату регистрации"
            disabled={disabled}
            format={"DD.MM.YYYY"}
            disabledDate={current => moment() <= current}
          />
        )}
      </Form.Item>
      <span className="label">Наименование лицензирующего&nbsp;органа:</span>
      <Form.Item>
        {getFieldDecorator("license_author")(
          <Input
            style={{ width: 368 }}
            placeholder="Укажите наименование организации"
            disabled={disabled}
          />
        )}
      </Form.Item>
    </>
  );
};

export default VehicleLicenseInfo;
